var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 104,
    viewBox: "0 0 119 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1099 76.13C16.6511 76.13 17.0899 75.6912 17.0899 75.15C17.0899 74.6087 16.6511 74.17 16.1099 74.17C15.5686 74.17 15.1299 74.6087 15.1299 75.15C15.1299 75.6912 15.5686 76.13 16.1099 76.13Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 35.17C71.2899 35.17 62.77 34.83 54.7999 32.61C46.9799 30.44 39.7999 26.23 33.3999 21.36C29.2099 18.19 25.3999 15.66 19.9599 16.04C14.638 16.328 9.54874 18.3153 5.43995 21.71C-1.48005 27.77 -0.440053 39 2.32995 46.86C6.48995 58.73 19.1499 67 29.9099 72.35C42.34 78.56 56 82.17 69.6899 84.24C81.6899 86.07 97.1099 87.39 107.51 79.56C117.06 72.35 119.68 55.91 117.34 44.81C116.772 41.5309 115.026 38.5721 112.43 36.49C105.72 31.58 95.7099 34.86 88.1699 35.02C85.3699 35.08 82.52 35.15 79.66 35.17Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2299 85.48C68.4652 85.48 73.5199 80.4253 73.5199 74.19C73.5199 67.9547 68.4652 62.9 62.2299 62.9C55.9946 62.9 50.9399 67.9547 50.9399 74.19C50.9399 80.4253 55.9946 85.48 62.2299 85.48Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5636 3.70614C51.1878 3.56696 51.8333 3.55208 52.4632 3.66237C53.0932 3.77265 53.6953 4.00594 54.2351 4.3489C54.7749 4.69187 55.2418 5.13779 55.6093 5.66122C55.9768 6.18465 56.2375 6.77534 56.3767 7.39954L58.1809 15.4908L48.6548 17.6149L46.8506 9.52364C46.7111 8.89778 46.6965 8.25053 46.8077 7.61902C46.9189 6.98752 47.1538 6.3842 47.4988 5.84368C47.8437 5.30316 48.2921 4.83609 48.818 4.46928C49.3439 4.10246 49.9371 3.84312 50.5636 3.70614Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0701 67.18L37.1801 80.08C36.8205 80.1607 36.4461 80.1462 36.0938 80.0381C35.7415 79.93 35.4235 79.7318 35.1711 79.4633C34.9187 79.1948 34.7407 78.8651 34.6546 78.5068C34.5685 78.1484 34.5773 77.7739 34.6801 77.42L34.9201 76.59C36.9201 69.5 38.6601 61.69 37.0601 54.49L33.6401 39.13C30.7601 26.22 38.5001 13.07 51.3401 9.89999C54.4711 9.12272 57.7259 8.97958 60.9131 9.47899C64.1002 9.9784 67.1553 11.1103 69.8984 12.808C72.6416 14.5057 75.0175 16.735 76.8863 19.3646C78.7551 21.9942 80.079 24.9711 80.7801 28.12L84.3101 44C85.9201 51.2 90.7801 57.56 95.6401 63.1L96.2101 63.75C96.4409 64.0283 96.597 64.3609 96.6637 64.7162C96.7305 65.0716 96.7057 65.4381 96.5916 65.7812C96.4776 66.1244 96.2781 66.4328 96.0119 66.6775C95.7457 66.9222 95.4216 67.0951 95.0701 67.18Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 51.5C60.5 52.5 65.5 52 69 49",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1099 41.05C70.8942 41.05 71.5299 40.4143 71.5299 39.63C71.5299 38.8458 70.8942 38.21 70.1099 38.21C69.3257 38.21 68.6899 38.8458 68.6899 39.63C68.6899 40.4143 69.3257 41.05 70.1099 41.05Z",
    fill: "#BABABA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0899 45.96C48.8742 45.96 49.5099 45.3242 49.5099 44.54C49.5099 43.7557 48.8742 43.12 48.0899 43.12C47.3057 43.12 46.6699 43.7557 46.6699 44.54C46.6699 45.3242 47.3057 45.96 48.0899 45.96Z",
    fill: "#BABABA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5701 2.19999C75.1113 2.19999 75.5501 1.76123 75.5501 1.21999C75.5501 0.678751 75.1113 0.23999 74.5701 0.23999C74.0289 0.23999 73.5901 0.678751 73.5901 1.21999C73.5901 1.76123 74.0289 2.19999 74.5701 2.19999Z",
    fill: "#CFCFCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1099 76.13C16.6511 76.13 17.0899 75.6912 17.0899 75.15C17.0899 74.6087 16.6511 74.17 16.1099 74.17C15.5686 74.17 15.1299 74.6087 15.1299 75.15C15.1299 75.6912 15.5686 76.13 16.1099 76.13Z",
    fill: "#CFCFCF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.65 24.89V29.19",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 27.04H103.8",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.61 89.63V93.93",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.46 91.78H105.76",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4299 8.59003V12.89",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.28 10.74H30.58",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5801 103.7C79.8545 103.7 96.2901 102.675 96.2901 101.41C96.2901 100.145 79.8545 99.12 59.5801 99.12C39.3057 99.12 22.8701 100.145 22.8701 101.41C22.8701 102.675 39.3057 103.7 59.5801 103.7Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 22.45C94.6473 25.4912 93.438 28.4071 91.2875 30.5576C89.1371 32.7081 86.2212 33.9174 83.1799 33.92C82.8058 33.92 82.4319 33.8999 82.0599 33.86L78.6599 39.41L77.5999 32.46C75.8335 31.4764 74.3584 30.0433 73.3242 28.306C72.2899 26.5687 71.7333 24.5889 71.7107 22.5671C71.6881 20.5454 72.2002 18.5536 73.1954 16.7936C74.1905 15.0336 75.6331 13.5679 77.3771 12.545C79.1211 11.5221 81.1046 10.9784 83.1264 10.9689C85.1482 10.9595 87.1366 11.4847 88.8901 12.4912C90.6436 13.4978 92.0999 14.9499 93.1114 16.7006C94.1229 18.4512 94.6537 20.4381 94.6499 22.46V22.45Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2801 23.61C78.9208 23.61 79.4401 23.0906 79.4401 22.45C79.4401 21.8093 78.9208 21.29 78.2801 21.29C77.6395 21.29 77.1201 21.8093 77.1201 22.45C77.1201 23.0906 77.6395 23.61 78.2801 23.61Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.18 23.61C83.8207 23.61 84.34 23.0906 84.34 22.45C84.34 21.8093 83.8207 21.29 83.18 21.29C82.5394 21.29 82.02 21.8093 82.02 22.45C82.02 23.0906 82.5394 23.61 83.18 23.61Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0799 23.61C88.7206 23.61 89.2399 23.0906 89.2399 22.45C89.2399 21.8093 88.7206 21.29 88.0799 21.29C87.4393 21.29 86.9199 21.8093 86.9199 22.45C86.9199 23.0906 87.4393 23.61 88.0799 23.61Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoNotification);
export default __webpack_public_path__ + "static/media/ic_no_notification.2d581fd594d530620a57a52542b2067f.svg";
export { ForwardRef as ReactComponent };